import { LitElement } from 'lit';
import * as THREE from 'three';

export class ThreeMaterial extends LitElement {
  static properties = {
    color: { type: String },
    roughness: { type: Number },
    metalness: { type: Number },
    opacity: { type: Number },
    type: { type: String },
  };

  constructor() {
    super();
    this.color = '#ffffff';
    this.roughness = 0.5;
    this.metalness = 0;
    this.opacity = 1;
    this.type = 'standard';
    this.material = null;
  }

  createMaterial() {
    const params = {
      color: new THREE.Color(this.color),
      transparent: this.opacity < 1,
      opacity: this.opacity,
    };
    switch (this.type) {
      case 'basic':
        return new THREE.MeshBasicMaterial(params);
      case 'normal':
        return new THREE.MeshNormalMaterial({ transparent: params.transparent, opacity: params.opacity });
      case 'phong':
        return new THREE.MeshPhongMaterial(params);
      case 'standard':
      default:
        return new THREE.MeshStandardMaterial({
          ...params,
          roughness: this.roughness,
          metalness: this.metalness,
        });
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.material = this.createMaterial();
    this._notifyParent();
  }

  updated(changed) {
    if (!this.material) return;
    if (changed.has('type')) {
      this.material.dispose();
      this.material = this.createMaterial();
      this._notifyParent();
      return;
    }
    if (changed.has('color') && this.material.color) this.material.color.set(this.color);
    if (changed.has('roughness') && 'roughness' in this.material) this.material.roughness = this.roughness;
    if (changed.has('metalness') && 'metalness' in this.material) this.material.metalness = this.metalness;
    if (changed.has('opacity')) {
      this.material.opacity = this.opacity;
      this.material.transparent = this.opacity < 1;
      this.material.needsUpdate = true;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.material) this.material.dispose();
  }

  _notifyParent() {
    this.dispatchEvent(new CustomEvent('material-changed', { bubbles: true, composed: true }));
  }

  createRenderRoot() {
    return this;
  }
}

customElements.define('three-material', ThreeMaterial);
